import { api } from './api';

const API_HOME_PATH = '/main/home';

export const fetchHomePageVod = async () => api.get(
	`${API_HOME_PATH}/vod`,
);
